import { reversalList } from "@/mocks/guaMore";

const statusColor: Record<string, string> = {
  二次反转: "bg-red-700 text-white",
  反转: "bg-orange-500 text-white",
  告一段落: "bg-emerald-600 text-white",
  待核: "bg-amber-100 text-amber-900",
  已实锤: "bg-red-700 text-white",
};

export default function Reversal() {
  return (
    <section id="reversal" className="w-full bg-[#f6efe3]">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="text-center">
          <p className="text-xs font-semibold tracking-[0.2em] text-red-700">反转与实锤</p>
          <h2 className="font-masthead mt-2 text-2xl font-black text-stone-900 md:text-3xl">
            反转盘点：谁被「打脸」，谁又翻红
          </h2>
          <p className="mx-auto mt-2 max-w-2xl text-sm text-stone-500">
            吃瓜最精彩的部分往往是反转。我们梳理近期事件的前后变化，带你一眼看清舆论攻守的完整过程。
          </p>
        </div>

        <div className="mt-8 grid gap-5 md:grid-cols-3">
          {reversalList.map((r) => (
            <article
              key={r.title}
              className="flex flex-col overflow-hidden rounded-xl border border-orange-900/10 bg-white p-5"
            >
              <div className="flex items-center justify-between">
                <span className="rounded-full bg-amber-100 px-2.5 py-1 text-xs font-medium text-amber-900">
                  {r.tag}
                </span>
                <span className={`rounded-full px-2.5 py-1 text-xs font-semibold ${statusColor[r.status] ?? "bg-stone-100 text-stone-600"}`}>
                  {r.status}
                </span>
              </div>
              <div className="mt-4 flex items-center gap-3">
                <div className="flex h-11 w-11 items-center justify-center rounded-full bg-red-50 text-red-700">
                  <i className="ri-loop-left-line text-xl"></i>
                </div>
                <h3 className="font-masthead flex-1 text-base font-bold leading-snug text-stone-900">{r.title}</h3>
              </div>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-stone-500">{r.summary}</p>
              <a
                href="#timeline"
                className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-red-700 hover:text-red-800"
              >
                查看完整反转时间线
                <i className="ri-arrow-right-line"></i>
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}